<template>
  <div class="SampleTracks">
    <div v-for="(track, index) in tracks" :class="{ 'flex group': editable }">
      <button
        :disabled="isLoading"
        @click="isPlaying === index ? pause(index) : play(index)"
        :ref="setButtonRef"
        class="w-full flex-grow text-left focus:ring focus:outline-none rounded px-gr-2 -ml-gr-2"
      >
        <span :class="{ hidden: isLoading === null || isLoading !== index }"
          ><i class="mr-gr-2 fad fa-fw fa-spinner-third fa-spin"></i></span
        ><span :class="{ hidden: isLoading === index || isPlaying === index }"
          ><i class="mr-gr-2 fa fa-fw fa-play-circle"></i></span
        ><span
          :class="{
            hidden: isLoading === index || isPlaying === null || isPlaying !== index,
          }"
          ><i class="mr-gr-2 fa fa-fw fa-pause-circle"></i></span
        >{{ track.name }}
      </button>

      <form v-if="editable" :action="route('admin.track.sample', { track })" method="POST">
        <input type="hidden" name="_token" :value="$page.props.csrf_token" />
        <input type="hidden" name="is_sample" value="0" />
        <button
          title="Not a Sample"
          type="submit"
          class="px-gr-4 text-sm whitespace-nowrap opacity-30 duration-200 group-hover:hover:opacity-100"
        >
          <i class="fal fa-fw fa-times"></i> Remove Sample
        </button>
      </form>
      <audio
        class="hidden"
        :ref="setAudioRef"
        controls
        :title="track.name"
        :src="track.track"
      ></audio>
    </div>
  </div>
</template>

<script>
  import { AudioBus } from '@/Utils/bus';

  export default {
    name: 'SampleTracks',

    props: {
      tracks: Array,
      book: Object,
      editable: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        isPlaying: null,
        isLoading: null,
        lastPlayed: null,
        audioElements: [],
        buttons: [],
      };
    },

    mounted() {
      AudioBus.$on('playNow', ({ playSample }) => {
        if (!playSample) return;
        if (this.isPlaying !== null) {
          this.pause(this.isPlaying, this.tracks[this.isPlaying]);
        } else {
          this.play(0, this.tracks[0]);
        }
      });
    },

    beforeUpdate() {
      this.audioElements = [];
      this.buttons = [];
    },

    beforeUnmount() {
      AudioBus.$off('playNow');
    },

    methods: {
      async pauseAllTracks() {
        this.audioElements.forEach(async (audio) => {
          await audio.pause();
          this.isPlaying = null;
        });
      },

      async play(index) {
        this.isLoading = index;
        const audio = this.audioElements[index];
        if (this.lastPlayed !== index) {
          audio.currentTime = 0;
        }

        this.pauseAllTracks().then(async () => {
          await audio.play();
          this.isLoading = null;
          this.buttons[index].focus();
          this.isPlaying = index;
          this.lastPlayed = index;
          AudioBus.$emit('play', { index, audio, event: 'play' });
        });
      },

      async pause(index) {
        const audio = this.audioElements[index];
        await audio.pause();
        this.isPlaying = null;
        AudioBus.$emit('pause', { index, audio, event: 'pause' });
      },

      setAudioRef(el) {
        if (el) {
          this.audioElements.push(el);
        }
      },

      setButtonRef(el) {
        if (el) {
          this.buttons.push(el);
        }
      },
    },
  };
</script>

<!-- <style lang="scss" src="./SampleTracks.scss" scoped></style> -->
